import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  // 90 seconds is plenty for LLM chat calls; anything longer is a hang, not a slow response
  timeout: 90000,
});

// Attach Authorization header when a token exists
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("pf_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Auto-clear stale/invalid tokens on 401 so subsequent requests don't keep sending bad creds.
// This does NOT redirect — the AuthProvider handles that via its user state.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      try { localStorage.removeItem("pf_token"); } catch (_) { /* ignore storage errors */ }
    }
    return Promise.reject(err);
  }
);
